import {
    linkedInCheckPassword,
} from '../utils/sign-up';
import { getFreeRegisterUrlParams, getVar } from '../utils/get-register-url-params';
import { Toast } from 'patsnap-biz'
import { openMessageBox } from '../components/message-box/messageBox';
import { useI18n } from 'vue-i18n';
import _ from 'lodash'
import { useChannels } from './use-channels';
import { ERROR_CODE } from '../types/error-codes';
/**
 * 验证密码，邮箱账号已经存在时
 * @param data
 * @returns
 */
async function checkPassword(data: { email: string }) {
    const password = await openMessageBox({
        email: data.email,
    });
    return password;
}

function getErrorCode(error: unknown) {
    const code =
        _.get(error, 'response.data.errcode') ||
        _.get(error, 'response.data.numeric_error_code');

    return `${code}`;
}

export function useLinkedInLogin() {
    const { t, te } = useI18n();
    const { channels } = useChannels()

    function alertErrorByCode(data: { code: string | number; email: string }) {
        const { code } = data;
        const defaultCode = 'unknown';
        const codeKey = te(`us.google_login.${code}`) ? code : defaultCode
        const message = t(`us.google_login.error_code.${codeKey}`)
        Toast({
            message,
            type: 'error',
            duration: 3000,
        });
    }

    const PassportUrl = import.meta.env.VITE_PASSPORT_URI;

    async function handleErrorOnLinkedLogin() {
        const code = getVar('errorCode')
        const email = getVar('email')
        if (code === ERROR_CODE.LINKED_IN_NEED_PASSWORD_CONFIRM) {
            const password = await checkPassword({ email });
            if (!password) return;
            try {
                await linkedInCheckPassword({ password, email });
                window.location.reload();
            } catch (err) {
                const code = getErrorCode(err);
                alertErrorByCode({ code, email });
            }
        }
    }

    const registerParams = getFreeRegisterUrlParams();
    const data = {
        ...channels.value,
        ...registerParams,
        redirect_uri: location.href,
    };
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        // @ts-ignore
        params.append(key, data[key]);
    });

    const linkedInLink = `${PassportUrl}/oauth2/authorization/linkedin?${params.toString()}`;

    return {
        handleErrorOnLinkedLogin,
        linkedInLink,
    };
}
